export default __webpack_public_path__ + "static/ntc-logo-938ec8c570faa5111b47a91de2940a1c.jpg";